import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useEffect } from 'react';
import useResizeObserver from '@elliemae/ds-utilities/hooks/useResizeObserver';
import { mergeRefs } from '@elliemae/ds-utilities/system';
import { getScrollbarSizeFromHeaderAndBody } from '../utils.js';
import '@elliemae/ds-utilities/utils';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function getTableProps(tableProps, _ref) {
  var refs = _ref.refs,
      tableRef = _ref.tableRef,
      bodyWidth = _ref.bodyWidth,
      scrollbarWidth = _ref.scrollbarWidth,
      isDragging = _ref.isDragging,
      columnSizeService = _ref.columnSizeService,
      updateRowWidth = _ref.updateRowWidth,
      columns = _ref.columns;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      tableNode = _useState2[0],
      tableRefCallback = _useState2[1];

  useResizeObserver(function (_ref2) {
    var width = _ref2.width;
    if (!refs.header.current) return;
    if (typeof scrollbarWidth.current !== 'number') scrollbarWidth.current = getScrollbarSizeFromHeaderAndBody(refs);
    if (typeof bodyWidth.current !== 'number') bodyWidth.current = refs.body.offsetWidth; // DataGrid: header with width 0 after redirect from details page (https://jira.elliemae.io/browse/PUI-2162)
    // if (scrollbarWidth.current !== 0 && width - scrollbarWidth.current > 0) {
    //   refs.header.current.style.width = `${width - scrollbarWidth.current}px`
    // }

    if (isDragging.current) return;
    columnSizeService.updateMissingWidths(width);
    updateRowWidth(width);
  }, tableNode);
  useEffect(function () {
    if (tableNode) {
      columnSizeService.updateMissingWidths(tableNode.clientWidth);
      updateRowWidth(tableNode.clientWidth);
    }

    if (typeof bodyWidth.current !== 'number') bodyWidth.current = refs.body.clientWidth;
  }, [columns, tableNode]);
  return _objectSpread(_objectSpread({}, tableProps), {}, {
    innerRef: mergeRefs(tableRefCallback, tableProps.innerRef, tableRef)
  });
}

export { getTableProps };
//# sourceMappingURL=getTableProps.js.map
